export default {
  stats: [
    { value: "200+", label: "Camiones Lanzados" },
    { value: "34", label: "Ciudades del Condado de Orange Cubiertas" },
    { value: "98%", label: "Tasa de Aprobación de Permisos" },
    { value: "10 Sem", label: "Tiempo Prom. para Lanzar" },
  ],
  headingTag: "Simple. Probado. Efectivo.",
  title1: "Cómo Te Ponemos",
  title2: "En el Camino",
  subtitle:
    "Desde tu primera llamada hasta tu primer día de servicio, manejamos cada paso del proceso de lanzamiento de un food truck en el Condado de Orange para que puedas concentrarte en la comida.",
  steps: [
    {
      title: "Reserva una Sesión",
      description:
        "Completa nuestro formulario de admisión y agenda una sesión con uno de nuestros especialistas en food trucks del Condado de Orange. Revisamos tu concepto, objetivos y cronograma antes de empezar.",
    },
    {
      title: "Obtén Tu Hoja de Ruta Personalizada",
      description:
        "Creamos un plan de acción personalizado que cubre cada permiso, licencia y requisito de cumplimiento específico para tu ciudad en el Condado de Orange — sin adivinanzas.",
    },
    {
      title: "Nosotros Hacemos el Trabajo Pesado",
      description:
        "Nuestro equipo guía tus solicitudes de permisos, acuerdos de comisaría, inspecciones de salud y requisitos del vehículo paso a paso para que nada se escape.",
    },
    {
      title: "Sal a la Calle y Empieza a Ganar",
      description:
        "Con todas las aprobaciones aseguradas, sales a las calles con total confianza. Nos mantenemos disponibles para renovaciones, expansiones y cualquier nuevo permiso de ciudad que necesites más adelante.",
    },
  ],
  ctaText: "¿Listo para comenzar el proceso?",
  bookSession: "Reservar una Sesión",
};